import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { getIn } from "formik"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch } from "react-redux"
import NumberFormat from "react-number-format"
import FormLabel from "../../../shared/formLabel"

function FormTimeTextbox(props) {
  const {
    textDesc,
    form,
    field,
    coverageCategory,
    coverageCode,
    formIsValid,
    formName,
    clickedNext,
  } = props

  const dispatch = useDispatch()
  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const handleTextChange = (event, error, category, coverageCode) => {
    const inputName = event.target.name
    const inputValue = event.target.value

    dispatch(
      updateCategoryClaimData(category, coverageCode, inputName, inputValue)
    )
    dispatch(formIsValidUpdate(formName, formIsValid))

    form.resetForm()
    form.validateForm()
  }

  const inputErrorClassName = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    //   (errors[inputName] && touched[inputName])
    //   ? "is-invalid"
    //   : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return (clickedNext && errors[inputName]) ||
      (errors[inputName] && touched[inputName]) ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const timeFormat = val => {
    let hour = limit(val.substring(0, 2), "23")
    let minute = limit(val.substring(2, 4), "59")

    return hour + (minute.length ? ":" + minute : "")
  }

  const limit = (val, max) => {
    if (val.length === 2) {
      //this can happen when user paste number
      if (val > max) {
        val = max
      }
    }
    return val
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <NumberFormat
            name={field.name}
            placeholder="HH:mm"
            className={
              "inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            format={timeFormat}
            onChange={form.handleChange}
            //onBlur={form.handleBlur}
            onBlur={event => {
              form.handleBlur(event)

              handleTextChange(
                event,
                form.errors,
                coverageCategory,
                coverageCode
              )
            }}
            maxLength={5}
            autoComplete="new-password"
            value={field.value || ""}
          />
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {/* <span className="InputError">{errors}</span> */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormTimeTextbox
